// extracted by mini-css-extract-plugin
export default {"menuItemsWithIcon":"actionMenuItemWithIcon_menuItemsWithIcon__SgEBy","inactive":"actionMenuItemWithIcon_inactive__z0E1P"};